module.exports = __webpack_public_path__ + "media/Unlock.1de79e95.webm";